import React, { Component } from "react";
import Question from "./question";
import Button from "../common/button";
import MyTooltip from "../common/my-tooltip";
import { Progress } from "reactstrap";
import LeftMenu from "../left-menu/left-menu";
import { submitQuestionsVideo } from "../../entry-videos.json";
import { allQuestions } from "../../questions.json";
import questionService from "../../services/questionService";

class SubmitQuestions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      course: this.props.match.params.course,
      current_chapter: "",
      current_question: {},
      selectedAnswers: [],
      questions: [],
      showMenu: false,
      hideMenu: false,
      success: null,
      correct: null,
      allowSubmit: true,
      message: "",
      color: "",
      totalPoints: 0,
      // Quiz revision fields
      currentRevision: 0, // From questions.json
      userRevision: 0, // From backend (stored quiz_revision)
      revisionMismatch: false, // Whether revisions differ
      showRedoPrompt: false, // Whether to show "New version available" CTA
      prevRevisionScore: 0, // Score from previous revision
      isRedoMode: false, // Whether user is redoing the quiz
      hasAttempted: false, // Whether user has any prior Quiz submissions
      showOldRevisionScore: false, // Old revision score shown only until redo is used
    };
  }

  componentDidMount() {
    const { course, chapterId, id } = this.props.match.params;
    // Chapter-level revision, co-located in questions.json (default 0)
    const current_chapter = allQuestions.find(
      (p) => p.chapter === parseInt(chapterId)
    );
    const chapterRevision =
      current_chapter && current_chapter.quiz_revision != null
        ? current_chapter.quiz_revision
        : 0;

    questionService
      .getQuestionByChapterId("ki_and_society", chapterId)
      .then(({ data: response }) => {
        questionService
          .getMultipleQuestionsByType("ki_and_society")
          .then(({ data: responsePoints }) => {
            let chapterPoints = responsePoints.filter(
              (p) => p.chapter_id === chapterId
            );
            let totalPoints = 0;
            chapterPoints.map((pointItem) => {
              totalPoints += pointItem.correct_answers_count
                ? pointItem.correct_answers_count
                : 0;
            });

            // Chapter-level revision from questions.json (source of truth, co-located per chapter)
            const currentRevision = chapterRevision;

            // Chapter-wide redo state derived from ALL chapter docs (backend is the
            // source of truth). Prefer the max so a partially-redone chapter behaves
            // like a redo started once any doc is on the current revision or any doc
            // carries last_redo_revision = currentRevision (bulk-set by the backend).
            const maxRevision = chapterPoints.reduce(
              (m, p) => Math.max(m, p.quiz_revision || 0),
              0
            );
            const maxLastRedo = chapterPoints.reduce(
              (m, p) =>
                Math.max(
                  m,
                  p.last_redo_revision != null ? p.last_redo_revision : -1
                ),
              -1
            );
            const maxPrevScore = chapterPoints.reduce(
              (m, p) => Math.max(m, p.prev_revision_score || 0),
              0
            );

            const redoDone =
              maxLastRedo >= currentRevision || maxRevision >= currentRevision;
            const userRevision = redoDone ? currentRevision : maxRevision;
            const prevRevisionScore = maxPrevScore;
            const hasAttempted = chapterPoints.length > 0;
            const revisionMismatch =
              hasAttempted && !redoDone && currentRevision > maxRevision;
            const showRedoPrompt = revisionMismatch;
            // Old revision score is shown only while the redo has NOT been used yet.
            // Once the user clicks "Quiz wiederholen" and submits the new revision,
            // the Punkte panel reflects the new revision attempt only.
            const showOldRevisionScore =
              prevRevisionScore > 0 && revisionMismatch;

            this.setState({
              totalPoints,
              userRevision,
              currentRevision,
              prevRevisionScore,
              hasAttempted,
              revisionMismatch,
              showRedoPrompt,
              showOldRevisionScore,
            });
          });

        let correct = null;
        let subState = { message: "", color: "", allowSubmit: true };
        let selectedAnswers = [];
        let question_response = response.find(
          (p) => p.quiz_id === parseInt(id)
        );
        let current_questions = current_chapter.questions;
        let current_question = current_questions.find(
          (p) => p.id === parseInt(id)
        );
        // Hydrate the question's answers from the user's saved attempt so that
        // previously-selected choices show their active border on reload or when
        // returning in a new session (matches the original behavior). This runs
        // for both the normal and redo-fresh cases; in redo-fresh the answers
        // stay interactive but the user still sees their previous selection.
        // We clone the question (answers included) to avoid mutating the static
        // imported questions.json module across navigations.
        if (question_response && question_response.answers) {
          current_question = {
            ...current_question,
            answers: current_question.answers.map((answer) => {
              const saved = question_response.answers.find(
                (p) => p.id === answer.id
              );
              return saved ? { ...answer, checked: saved.checked } : answer;
            }),
          };
        }
        if (question_response) {
          // The backend is the source of truth for redo state. A previously-attempted
          // question stays locked/green only if it is on the CURRENT revision and the
          // redo for this chapter has NOT been marked done. Otherwise it is a fresh,
          // retryable attempt of the new revision.
          const savedRevision = question_response.quiz_revision || 0;
          const savedLastRedo =
            question_response.last_redo_revision != null
              ? question_response.last_redo_revision
              : -1;
          const savedNumAttempts = question_response.num_attempts || 0;

          const isRedoFresh =
            savedRevision < chapterRevision ||
            (savedLastRedo === chapterRevision && savedNumAttempts < 3);

          if (isRedoFresh) {
            // Fresh redo question: interactive, no old highlights shown, not locked.
            correct = null;
            selectedAnswers = [];
            subState = { message: "", color: "", allowSubmit: true };
          } else {
            correct = question_response.correct;
            selectedAnswers = question_response.answers;
            subState = this.handleMessage(question_response, true);
          }
        }
        this.setState({
          questions: [].concat(current_questions),
          current_question,
          current_chapter,
          correct,
          selectedAnswers,
          message: subState.message,
          color: subState.color,
          allowSubmit: subState.allowSubmit,
        });
      })
      .catch((err) => {});
  }

  bodyOverflowClass = (show) => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    if (show) document.body.classList.add("overflowHidden");
    else document.body.classList.remove("overflowHidden");
  };

  showLeftMenu = (show) => {
    this.bodyOverflowClass(show);
    this.setState({
      showMenu: show,
      hideMenu: !show,
    });
  };

  submitQuestions = () => {
    const { chapterId } = this.props.match.params;
    const { current_question, currentRevision } = this.state;
    let questionSubmit = {};
    questionSubmit.id = current_question.id;
    questionSubmit.chapterId = chapterId;
    questionSubmit.type = "ki_and_society";
    questionSubmit.answers = current_question.answers;
    questionSubmit.quiz_revision = currentRevision; // NEW: include revision in payload
    questionService
      .submitQuestions(questionSubmit)
      .then(({ data: response }) => {
        questionService
          .getMultipleQuestionsByType("ki_and_society")
          .then(({ data: responsePoints }) => {
            let chapterPoints = responsePoints.filter(
              (p) => p.chapter_id === chapterId
            );
            let totalPoints = 0;
            chapterPoints.map((pointItem) => {
              totalPoints += pointItem.correct_answers_count;
            });

            // Update revision state from the backend's saved document (chapter revision).
            // After a successful submission on the current revision, there is no mismatch
            // and no redo prompt.
            this.setState({
              totalPoints,
              userRevision: response.quiz_revision || 0,
              prevRevisionScore: response.prev_revision_score || 0,
              hasAttempted: chapterPoints.length > 0,
              revisionMismatch: false,
              showRedoPrompt: false,
              showOldRevisionScore: false,
            });
          });
        let selectedAnswers = response.answers;
        let subState = this.handleMessage(response, false);

        this.setState({
          correct: response.correct,
          success: true,
          selectedAnswers,
          message: subState.message,
          color: subState.color,
          allowSubmit: subState.allowSubmit,
        });
      })
      .catch((err) => {
        console.error("Submission failed:", err);
        let errorMsg =
          "Beim Senden ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.";
        if (
          err.response &&
          err.response.data &&
          err.response.data.description
        ) {
          errorMsg = err.response.data.description;
        }
        // Don't re-show redo prompt if user was already in redo mode
        // The backend error may be due to redo being already used or attempts limit
        this.setState({
          success: false,
          message: errorMsg,
          color: "message-wrong",
          showRedoPrompt: !this.state.isRedoMode, // Only re-show if not in redo mode
          allowSubmit: true,
        });
      });
  };

  onNextButton = () => {
    const { chapterId, id } = this.props.match.params;
    const { course } = this.state;
    this.props.history.push(
      `/ethics/course=${course}/chapter=${chapterId}/id=${parseInt(id) + 1}`
    );
  };

  onPreviousButton = () => {
    const { chapterId, id } = this.props.match.params;
    const { course } = this.state;
    this.props.history.push(
      `/ethics/course=${course}/chapter=${chapterId}/id=${parseInt(id) - 1}`
    );
  };

  onHomeButton = () => {
    const { course } = this.state;
    this.props.history.push(`/ethics/course=${course}`);
  };

  onHandleChange = (id, index) => {
    const { current_question } = this.state;
    current_question.answers[index].checked =
      !current_question.answers[index].checked;
    this.setState({
      current_question,
    });
  };

  // NEW: Handle redo - reset the quiz for the new revision (chapter-wide)
  onRedoQuiz = () => {
    const { chapterId } = this.props.match.params;
    this.setState(
      {
        isRedoMode: true,
        showRedoPrompt: false,
        revisionMismatch: false,
        // currentRevision already holds the chapter-level revision from questions.json
        selectedAnswers: [],
        correct: null,
        allowSubmit: true,
        message: "",
        color: "",
      },
      () => {
        // Reset all question answers to unchecked
        const { questions, current_question } = this.state;
        const resetQuestion = JSON.parse(JSON.stringify(current_question));
        resetQuestion.answers.forEach((answer) => {
          answer.checked = false;
        });
        this.setState({
          current_question: resetQuestion,
          questions: questions.map((q) => {
            const resetQ = JSON.parse(JSON.stringify(q));
            resetQ.answers.forEach((answer) => {
              answer.checked = false;
            });
            return resetQ;
          }),
        });
      }
    );
  };

  handleMessage = (response, load) => {
    let message = "";
    let color = "";
    let allowSubmit = true;

    if (load && (response.correct || response.num_attempts === 3)) {
      message = "";
      color = "";
      allowSubmit = false;
      return { message: message, color: color, allowSubmit: allowSubmit };
    }

    if (response.num_attempts < 3) {
      if (response.correct) {
        message = "Super. Du hast Punkte gesammelt.";
        color = "message-correct";
        allowSubmit = false;
      } else {
        message = "Noch nicht ganz richtig. Versuche es nochmal.";
        color = "message-more";
      }
    } else if (response.num_attempts === 3) {
      allowSubmit = false;
      if (response.correct) {
        message = "Super. Du hast Punkte gesammelt.";
        color = "message-correct";
      } else {
        if (response.correct_answers_count === 0) {
          message = "Schade, diesmal hast du leider keine Punkte gesammelt.";
          color = "message-wrong";
        } else if (response.correct_answers_count > 0) {
          message =
            "Du erhältst Punkte, abzüglich der falsch gewählten Antworten.";
          color = "message-partial";
        }
      }
    }

    return { message: message, color: color, allowSubmit: allowSubmit };
  };

  render() {
    const {
      current_question,
      questions,
      success,
      correct,
      current_chapter,
      selectedAnswers,
      allowSubmit,
      totalPoints,
      showRedoPrompt,
      revisionMismatch,
      prevRevisionScore,
      currentRevision,
      userRevision,
      isRedoMode,
      showOldRevisionScore,
    } = this.state;
    const { course, chapterId, id } = this.props.match.params;
    let maxQuestions;
    if (questions) {
      maxQuestions = questions.length;
    }

    // Auswerten stays hidden until the user clicks "Quiz wiederholen" when their
    // stored revision is behind the current chapter revision (prevents retry-cheat).
    const canSubmit = allowSubmit && !(revisionMismatch && !isRedoMode);

    return (
      <React.Fragment>
        {current_question && (
          <React.Fragment>
            <section className="content question">
              <div className="container-fluid">
                <div className="container-limit my-limit">
                  <div className="progressBar">
                    <div className="progress-table-bar">
                      {/* <div>
                                                <Progress value={questions.indexOf(current_question)+1} max={maxQuestions}><span>{questions.indexOf(current_question)+1}/{maxQuestions}</span></Progress>
                                            </div> */}
                      <div className="progress-div">
                        <Progress
                          value={questions.indexOf(current_question) + 1}
                          max={maxQuestions}
                        ></Progress>
                        <div className="progress-span">
                          {questions.indexOf(current_question) + 1}/
                          {maxQuestions}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="task-item-lightheader">
                    Kategorie {current_chapter ? current_chapter.title : ""}
                  </div>
                  <div className="task-item-mainheader">
                    {current_question.title}{" "}
                    {current_question && current_question.link && (
                      <a
                        href={current_question.link}
                        className="primary-color-lightgreen-foreground ml-4"
                        target="_blank"
                      >
                        zum Artikel
                      </a>
                    )}
                  </div>

                  {/* NEW: Redo prompt when revision changed */}
                  {showRedoPrompt && (
                    <div className="redo-prompt">
                      <p>
                        <strong>Dieses Kapitel wurde aktualisiert!</strong>
                      </p>
                      <p>
                        Verschiedene Fragen und Antwortmöglichkeiten wurden
                        überarbeitet. Sie können das Quiz jetzt wiederholen, um
                        Ihre Punktzahl für die neue Version zu erhalten.
                      </p>
                      <button onClick={this.onRedoQuiz} className="redo-button">
                        Quiz wiederholen
                      </button>
                      {prevRevisionScore > 0 && (
                        <div className="prev-score-info">
                          Ihre vorherige Punktzahl (v{userRevision}):{" "}
                          <strong>{prevRevisionScore}</strong> Punkte
                        </div>
                      )}
                    </div>
                  )}

                  {/* NEW: Show revision mismatch warning */}
                  {revisionMismatch && !showRedoPrompt && (
                    <div className="revision-warning">
                      <span>
                        Ihre bisherigen Antworten stammen von einer älteren
                        Version (v{userRevision}). Die Musterlösung wird für die
                        alte Version angezeigt.
                      </span>
                    </div>
                  )}

                  <div className="question-wrapper">
                    <Question
                      correct={correct}
                      key={current_question.id}
                      question={current_question}
                      onChange={this.onHandleChange}
                      showLink={false}
                      selectedAnswers={selectedAnswers}
                      type="quiz"
                      showAnswers={!allowSubmit}
                      revisionMismatch={revisionMismatch}
                      userRevision={userRevision}
                    />

                    {this.state.message && !(this.state.message === "") && (
                      <div className={`question-info ${this.state.color}`}>
                        <span>{this.state.message}</span>
                      </div>
                    )}
                    {!this.state.allowSubmit && (
                      <div className="question-info message-answers">
                        <span>
                          Musterlösung - dies sind alle korrekten Antworten!
                        </span>
                      </div>
                    )}

                    <div className="submit-parent-wrapper">
                      {questions.length > 0 && (
                        <div className="button-wrapper">
                          {/* Points panel is always visible (original UX). The value
                                                        reflects the current revision attempt; the old-revision
                                                        score is shown only until the redo has been used. */}
                          <div className="points-panel-wrapper">
                            <span>Punkte</span>
                            <div className="points-panel">{totalPoints}</div>
                            {showOldRevisionScore && (
                              <div className="prev-score-panel">
                                <span>
                                  (v{userRevision}: {prevRevisionScore})
                                </span>
                              </div>
                            )}
                          </div>
                          {questions.indexOf(current_question) !== 0 && (
                            <Button
                              onClick={this.onPreviousButton}
                              href="#"
                              className="firstBtn"
                              label="Vorherige Frage"
                            />
                          )}
                          {canSubmit && (
                            <Button
                              onClick={this.submitQuestions}
                              href="#"
                              className="secondBtn primary-color-lightblue-foreground"
                              label="Auswerten"
                            />
                          )}
                          {questions &&
                            questions.indexOf(current_question) + 1 <
                              questions.length && (
                              <Button
                                onClick={this.onNextButton}
                                href="#"
                                className="thirdBtn"
                                label="Nächste Frage"
                              />
                            )}
                          {questions &&
                            questions.indexOf(current_question) + 1 ===
                              questions.length && (
                              <Button
                                onClick={this.onHomeButton}
                                href="#"
                                className="thirdBtn"
                                label="Speichern"
                              />
                            )}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </React.Fragment>
        )}
        {!current_question && (
          <React.Fragment>
            <section className="content question">
              <div className="container-fluid">
                <div className="container-limit my-limit">
                  <div className="multiple-choise-video">
                    <div className="progressBar">
                      <div className="progress-table-bar">
                        <div>
                          <Progress value="0" max={maxQuestions}>
                            <span>0/{maxQuestions}</span>
                          </Progress>
                        </div>
                      </div>
                    </div>
                    <div className="video-wrapper">
                      <iframe
                        title="entry-video"
                        width="560"
                        height="315"
                        src={submitQuestionsVideo}
                        frameBorder="0"
                        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                      ></iframe>
                    </div>
                    <div className="button-video">
                      <Button
                        href="#"
                        onClick={this.goToFirst}
                        label="Weiter"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </React.Fragment>
        )}
      </React.Fragment>
    );
  }
}

export default SubmitQuestions;
